import {Dispatch} from "redux";

import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import {IFetchContext} from "@pg-mono/data-fetcher";
import {consoleError} from "@pg-mono/logger";
import {createRequestActionTypes} from "@pg-mono/request-state";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {fetchRegionReportPriceBySlug} from "../../../region/api/fetch_region_report_price_by_slug";

const FETCH_DISTRICT_REPORT_REGION = "reports/FETCH_DISTRICT_REPORT_REGION";
export const fetchDistrictReportRegionTypes = createRequestActionTypes(FETCH_DISTRICT_REPORT_REGION);

// A missing or invalid `dist` param is not an error - the route silently falls back to the city view
// (district stays null), so this never 404s the way fetchPriceReportRegion does for a bad city slug.
export const fetchDistrictReportRegion = (ctx: IFetchContext<IRPRequestMeta, {regionSlug: string}>) => async (dispatch: Dispatch) => {
    const distParam = ctx.route.query.dist as string | undefined;

    if (!distParam) {
        return true;
    }

    const citySlug = ctx.match.params.regionSlug;

    return fetchRegionReportPriceBySlug([`${citySlug}-${distParam}`])
        .then(([district]) => {
            if (district && district.slug.startsWith(`${citySlug}-`)) {
                dispatch({type: fetchDistrictReportRegionTypes.success, result: district});
            }

            return true;
        })
        .catch((error) => {
            // Same fallback as a missing/invalid dist param - the route falls back to the city view rather than failing.
            notifyBugsnagClient(error, "fetch_district_report_region");
            consoleError("fetchDistrictReportRegion error: ", error);

            return true;
        });
};
import {Dispatch} from "redux";

import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import {IFetchContext} from "@pg-mono/data-fetcher";
import {consoleError} from "@pg-mono/logger";
import {createRequestActionTypes} from "@pg-mono/request-state";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {fetchRegionReportPriceBySlug} from "../../../region/api/fetch_region_report_price_by_slug";

const FETCH_DISTRICT_REPORT_REGION = "reports/FETCH_DISTRICT_REPORT_REGION";
export const fetchDistrictReportRegionTypes = createRequestActionTypes(FETCH_DISTRICT_REPORT_REGION);

// A missing or invalid `dist` param is not an error - the route silently falls back to the city view
// (district stays null), so this never 404s the way fetchPriceReportRegion does for a bad city slug.
export const fetchDistrictReportRegion = (ctx: IFetchContext<IRPRequestMeta, {regionSlug: string}>) => async (dispatch: Dispatch) => {
    const distParam = ctx.route.query.dist as string | undefined;

    if (!distParam) {
        return true;
    }

    const citySlug = ctx.match.params.regionSlug;

    return fetchRegionReportPriceBySlug([`${citySlug}-${distParam}`])
        .then(([district]) => {
            if (district && district.slug.startsWith(`${citySlug}-`)) {
                dispatch({type: fetchDistrictReportRegionTypes.success, result: district});
            }

            return true;
        })
        .catch((error) => {
            // Same fallback as a missing/invalid dist param - the route falls back to the city view rather than failing.
            notifyBugsnagClient(error, "fetch_district_report_region");
            consoleError("fetchDistrictReportRegion error: ", error);

            return true;
        });
};
